<template>
	<modal @close="$emit('close')">
		<template slot="body">
			<md-card>
				<md-card-header class="md-card-header-icon md-card-header-accent">
					<div class="card-icon">
						<md-icon>cloud_upload</md-icon>
					</div>
					<h4 class="title"> {{ name }}</h4>
				</md-card-header>
				<md-card-content class="md-layout">
					<div v-if="description" v-html="description" style="margin-bottom: 15px" class="md-layout-item md-size-100">
					</div>
					<div class="md-layout-item md-size-100">
						<form enctype="multipart/form-data" novalidate>
							<div class="dropbox">
								<input type="file" multiple name="file" :disabled="isUploading" class="input-file" @change="uploadFiles($event.target.files)">
								<span>
									<p v-if="!isUploading">Arraste aqui o arquivo<br>ou clique para abrir o pesquisador</p>
									<p v-if="isUploading">Importando...</p>
								</span>
							</div>
						</form>
					</div>
				</md-card-content>
			</md-card>
		</template>
		<template slot="footer">
			<md-button class="md-danger" @click="$emit('close')">Cancelar</md-button>
		</template>
	</modal>
</template>

<script>
	import { Modal } from '@/components'
	import EspressoAux from "./EspressoAux.vue"

	export default {
		props: {
			name: String,
			uploadResource: Function,
			description: String,
		},
		components: {
			Modal,
		},
		data () {
			return {
				isUploading: false,
			}
		},
		methods: {
			uploadFiles(fileList) {
				EspressoAux.executeAsync(async () => {
					this.isUploading = true;
					await Promise.all(Array.from(fileList).map((file) => this.uploadResource(file)));
					this.isUploading = false;
					this.$emit("close");
					return EspressoAux.showSuccessModal();
				}, null, null, async (error) => {
					this.isUploading = false;
					this.$emit("close");
					if (error.error === "UPLOAD_REQUEST_TOO_LARGE") {
						return EspressoAux.showFailModal(`Tamanho do arquivo excede o limite de ${error.details.maxSize} MB.`);
					}
					return EspressoAux.showFailModal("Não foi possível importar!");
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.md-card .md-card-actions{
		border: none;
	}

	.text-center{
		justify-content: center !important;
	}

	.resource-container {
		position: relative;
	}

	.resource {
		height: 300px;
		max-width: 100%;
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		margin: 0 auto 15px;
	}

	.resource img {
		object-fit: contain;
		height: 100%;
		width: 100%;
	}

	.dropbox {
		outline: 2px dashed grey; /* the dash box */
		outline-offset: -10px;
		background: whitesmoke;
		color: dimgray;
		padding: 10px 20px;
		height: 300px;
		position: relative;
		cursor: pointer;

		line-height: 200px;
		text-align: center;
	}

	.input-file {
		opacity: 0; /* invisible but it's there! */
		width: 100%;
		height: 200px;
		position: absolute;
		cursor: pointer;
	}

	.dropbox:hover {
		background: rgba(198, 240, 198, 0.502); /* when mouse over to the drop zone, change color */
	}

	.dropbox p {
		font-size: 1.2em;
		text-align: center;
		margin-top: 0;
	}

	.dropbox span {
		display: inline-block;
		vertical-align: middle;
		line-height: normal;
	}

	.resource-button {
		width: 40px;
		height: 40px;
		border-radius: 100px;

		position: absolute;
		top: -5px;
		right: -5px;
	}
</style>
